var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-cart"},_vm._l((_vm.items),function(item){return _c('dentaid-cart-row',{key:item.sku,attrs:{"item":item,"event-bus":_vm.eventBus,"jwt-token":_setup.piniaStore.parsedToken,"dentaid-api-instance":_vm.dentaidApiInstance,"cart-event-bus":_vm.cartEventBus}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }